import addItemForm from "./addItemForm";
export default {
  uploadImageButtonText: addItemForm.uploadImageButtonText,
  cancel: "Cancel",
  cropSave: "Crop & Save",
};
